import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef4ea870"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "question-title-wrapper mb-14" }
const _hoisted_2 = { class: "question-title-index" }
const _hoisted_3 = {
  key: 0,
  class: "required-required"
}
const _hoisted_4 = {
  key: 1,
  class: "not-modified"
}
const _hoisted_5 = { class: "mt-20" }
const _hoisted_6 = { class: "fake-input-label d-flex justify-content-between" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "base-label" }, "Original Answer", -1))
const _hoisted_8 = { class: "fake-input" }
const _hoisted_9 = { class: "mt-20" }
const _hoisted_10 = { class: "fake-input-label d-flex justify-content-between" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "base-label" }, "New Answer", -1))
const _hoisted_12 = { class: "fake-input new-value-input" }
const _hoisted_13 = {
  key: 2,
  class: "question-error"
}
const _hoisted_14 = {
  key: 3,
  class: "d-flex justify-content-between align-items-center"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "how-does-this-look" }, " Hey does this look good? ", -1))
const _hoisted_16 = { class: "d-flex" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-10",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.2833 7.49995L11.995 14.9999M8.005 14.9999L7.71667 7.49995M16.0233 4.82495C16.3083 4.86828 16.5917 4.91411 16.875 4.96328M16.0233 4.82495L15.1333 16.3941C15.097 16.8651 14.8842 17.3051 14.5375 17.626C14.1908 17.9469 13.7358 18.1251 13.2633 18.1249H6.73667C6.26425 18.1251 5.80919 17.9469 5.46248 17.626C5.11578 17.3051 4.90299 16.8651 4.86667 16.3941L3.97667 4.82495M16.0233 4.82495C15.0616 4.67954 14.0948 4.56919 13.125 4.49411M3.97667 4.82495C3.69167 4.86745 3.40833 4.91328 3.125 4.96245M3.97667 4.82495C4.93844 4.67955 5.9052 4.56919 6.875 4.49411M13.125 4.49411V3.73078C13.125 2.74745 12.3667 1.92745 11.3833 1.89661C10.4613 1.86714 9.53865 1.86714 8.61667 1.89661C7.63333 1.92745 6.875 2.74828 6.875 3.73078V4.49411M13.125 4.49411C11.0448 4.33334 8.95523 4.33334 6.875 4.49411",
    stroke: "white",
    "stroke-width": "1.25",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-10",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.0517 3.73913L15.4575 2.33246C15.7506 2.0394 16.148 1.87476 16.5625 1.87476C16.977 1.87476 17.3744 2.0394 17.6675 2.33246C17.9606 2.62553 18.1252 3.02301 18.1252 3.43746C18.1252 3.85192 17.9606 4.2494 17.6675 4.54246L8.81833 13.3916C8.37777 13.8319 7.83447 14.1556 7.2375 14.3333L5 15L5.66667 12.7625C5.8444 12.1655 6.16803 11.6222 6.60833 11.1816L14.0517 3.73913ZM14.0517 3.73913L16.25 5.93746M15 11.6666V15.625C15 16.1222 14.8025 16.5992 14.4508 16.9508C14.0992 17.3024 13.6223 17.5 13.125 17.5H4.375C3.87772 17.5 3.40081 17.3024 3.04917 16.9508C2.69754 16.5992 2.5 16.1222 2.5 15.625V6.87496C2.5 6.37768 2.69754 5.90077 3.04917 5.54914C3.40081 5.19751 3.87772 4.99996 4.375 4.99996H8.33333",
    stroke: "white",
    "stroke-width": "1.25",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-10",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3.75 10.625L8.75 15.625L16.25 4.375",
    stroke: "white",
    "stroke-width": "1.25",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_20 = {
  key: 4,
  class: ""
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fake-input-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "base-label" }, "Edit Value")
], -1))
const _hoisted_22 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_23 = {
  key: 1,
  class: "mb-10"
}
const _hoisted_24 = {
  key: 2,
  class: "mb-10"
}
const _hoisted_25 = { class: "d-flex" }
const _hoisted_26 = {
  key: 3,
  class: "mb-10"
}
const _hoisted_27 = {
  key: 0,
  class: "d-flex flex-wrap"
}
const _hoisted_28 = {
  key: 4,
  class: "mb-10"
}
const _hoisted_29 = { class: "d-flex justify-content-between" }
const _hoisted_30 = { class: "d-flex" }
const _hoisted_31 = {
  key: 5,
  class: "top-gray-line"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rejecting-info" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M16.875 6.25L16.3542 15.11C16.3261 15.5875 16.1166 16.0363 15.7685 16.3644C15.4204 16.6925 14.96 16.8752 14.4817 16.875H5.51833C5.03997 16.8752 4.57962 16.6925 4.23152 16.3644C3.88342 16.0363 3.6739 15.5875 3.64583 15.11L3.125 6.25M8.125 9.6875L10 11.5625M10 11.5625L11.875 13.4375M10 11.5625L11.875 9.6875M10 11.5625L8.125 13.4375M2.8125 6.25H17.1875C17.705 6.25 18.125 5.83 18.125 5.3125V4.0625C18.125 3.545 17.705 3.125 17.1875 3.125H2.8125C2.295 3.125 1.875 3.545 1.875 4.0625V5.3125C1.875 5.83 2.295 6.25 2.8125 6.25Z",
      stroke: "#6B6B6B",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "You are rejecting this answer")
], -1))
const _hoisted_33 = { class: "input-box" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-label" }, [
  /*#__PURE__*/_createTextVNode("Explain your rejection "),
  /*#__PURE__*/_createElementVNode("span", { class: "input-label-optional" }, "(optional)")
], -1))
const _hoisted_35 = { class: "d-flex justify-content-between" }
const _hoisted_36 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_question_title = _resolveComponent("question-title")!
  const _component_CalendarSvg = _resolveComponent("CalendarSvg")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_question_option_input = _resolveComponent("question-option-input")!
  const _component_question_date_input = _resolveComponent("question-date-input")!
  const _component_radio_button = _resolveComponent("radio-button")!
  const _component_SearchMultipleSelect = _resolveComponent("SearchMultipleSelect")!
  const _component_select_input = _resolveComponent("select-input")!
  const _component_search_drop_down = _resolveComponent("search-drop-down")!
  const _component_new_confirm_modal = _resolveComponent("new-confirm-modal")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_ctx.question.is_answer_changed)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass({
        'question-wrapper': true,
        'is-rejecting': _ctx.questionAcceptRejectEdit.state === 'reject',
      })
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.count) + ".", 1),
              _createVNode(_component_question_title, {
                value: _ctx.question.text,
                "is-active": false
              }, null, 8, ["value"])
            ]),
            (_ctx.question.is_required)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, "*"))
              : _createCommentVNode("", true),
            (!_ctx.question.is_answer_changed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Not Modified"))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", null, [
                    _createVNode(_component_CalendarSvg),
                    _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.question.answer_history[1].created_at)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.renderAnswerValue(_ctx.question.answer_history[1], _ctx.question) || 'Undefined') + "  ", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", null, [
                    _createVNode(_component_CalendarSvg),
                    _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.question.answer_history[0].created_at)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.renderAnswerValue(_ctx.question.answer_history[0], _ctx.question)), 1)
              ])
            ]),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true),
            (_ctx.questionAcceptRejectEdit.state === null || _ctx.questionAcceptRejectEdit.state === 'accept')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_base_button, {
                      size: _ctx.small,
                      class: "feedback-button btn btn-base mr-5 mb-6",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.questionAcceptRejectEdit.state = 'reject'))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17,
                        _createTextVNode(" Reject ")
                      ]),
                      _: 1
                    }, 8, ["size"]),
                    _createVNode(_component_base_button, {
                      class: "feedback-button btn btn-base mr-5 mb-6",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.questionAcceptRejectEdit.state = 'edit';})
                    }, {
                      default: _withCtx(() => [
                        _hoisted_18,
                        _createTextVNode(" Edit ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_base_button, {
                      class: "feedback-button btn btn-base mr-5 mb-6",
                      onClick: _cache[2] || (_cache[2] = () => {
            _ctx.questionAcceptRejectEdit.state = 'accept';
            _ctx.questionAcceptRejectEdit.isPopConfirmOpened = true;
          })
                    }, {
                      default: _withCtx(() => [
                        _hoisted_19,
                        _createTextVNode(" Accept ")
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.questionAcceptRejectEdit.state === 'edit')
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _hoisted_21,
                  (_ctx.question.type === 'text')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createVNode(_component_question_option_input, {
                          placeholder: "Type your response",
                          value: _ctx.question.user_answer,
                          onOnValueChange: _ctx.handleValueUpdate
                        }, null, 8, ["value", "onOnValueChange"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.question.type === 'date')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createVNode(_component_question_date_input, {
                          placeholder: "Date",
                          value: typeof _ctx.question.user_answer === 'string' ? _ctx.question.user_answer : '',
                          onOnValueChange: _ctx.handleValueUpdate
                        }, null, 8, ["value", "onOnValueChange"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.question.type === 'yes_no')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.answer_values, (k, v) => {
                            return (_openBlock(), _createBlock(_component_radio_button, {
                              key: k,
                              class: "mr-10",
                              label: k,
                              value: v,
                              "is-active": _ctx.isResponseSelected(v),
                              onHandleValueChange: _ctx.handleYesNoChange
                            }, null, 8, ["label", "value", "is-active", "onHandleValueChange"]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.question.type === 'multiple')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        (Object.keys(_ctx.question.answer_values).length < 4)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.answer_values, (k, v) => {
                                return (_openBlock(), _createBlock(_component_radio_button, {
                                  key: k,
                                  class: "mr-10 mb-6",
                                  label: k,
                                  value: v,
                                  "is-active": _ctx.isResponseSelected(v),
                                  onHandleValueChange: _ctx.handleMultipleChange
                                }, null, 8, ["label", "value", "is-active", "onHandleValueChange"]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createBlock(_component_SearchMultipleSelect, {
                              key: 1,
                              question: _ctx.question,
                              onOnUpdate: _ctx.handleValueUpdate
                            }, null, 8, ["question", "onOnUpdate"]))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.question.type === 'drop_down')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        (Object.keys(_ctx.question.answer_values).length < 20)
                          ? (_openBlock(), _createBlock(_component_select_input, {
                              key: 0,
                              class: "mb-10",
                              value: _ctx.question.user_answer && _ctx.question.user_answer !== null ? _ctx.question.user_answer[0] : null,
                              options: _ctx.getSelectInputOptions(_ctx.question.answer_values),
                              onHandleChange: _ctx.handleSelectChange
                            }, null, 8, ["value", "options", "onHandleChange"]))
                          : (_openBlock(), _createBlock(_component_search_drop_down, {
                              key: 1,
                              options: _ctx.getSearchSelectInputOptions(_ctx.question.answer_values),
                              onSelected: _ctx.handleSearchSelectChange,
                              defaultValue: _ctx.question.user_answer  && _ctx.question.user_answer !== null ? {id: _ctx.question.user_answer[0], name: _ctx.question.answer_values[_ctx.question.user_answer[0]]} : null
                            }, null, 8, ["options", "onSelected", "defaultValue"]))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_base_button, {
                      variant: "outlined",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.questionAcceptRejectEdit.state = null))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancel")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_base_button, {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.questionAcceptRejectEdit.isPopConfirmOpened = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Save Edit")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.questionAcceptRejectEdit.state === 'reject')
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.questionAcceptRejectEdit.rejectReason) = $event)),
                      class: "input",
                      placeholder: "Enter your rejection reason",
                      type: "text"
                    }, null, 512), [
                      [_vModelText, _ctx.questionAcceptRejectEdit.rejectReason]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_base_button, {
                      variant: "outlined",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.questionAcceptRejectEdit.state = null))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancel")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_base_button, {
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.questionAcceptRejectEdit.isPopConfirmOpened = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Confirm Rejection")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_new_confirm_modal, {
              "is-visible": _ctx.questionAcceptRejectEdit.isPopConfirmOpened && _ctx.questionAcceptRejectEdit.state === 'reject',
              title: "Confirm Rejection to Answer",
              "accept-caption": 'Yes, reject it',
              "reject-caption": 'No, go back',
              onOnCancel: _cache[8] || (_cache[8] = ($event: any) => (_ctx.questionAcceptRejectEdit.isPopConfirmOpened = false)),
              onOnConfirm: _cache[9] || (_cache[9] = () => {
          // $emit('setQuestionResponseState',question.id, 'rejected');
          const cb = () => {
            _ctx.questionAcceptRejectEdit.isPopConfirmOpened = false;
            _ctx.questionAcceptRejectEdit.state = null;
          }
          _ctx.$emit('handleReviewQuestion', _ctx.question.id, _ctx.questionAcceptRejectEdit, cb);

        //   @todo show feedback message
        })
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Are you sure you want to reject \"" + _toDisplayString(_ctx.question.text) + "\"? ", 1)
              ]),
              _: 1
            }, 8, ["is-visible"]),
            _createVNode(_component_new_confirm_modal, {
              "is-visible": _ctx.questionAcceptRejectEdit.isPopConfirmOpened && _ctx.questionAcceptRejectEdit.state === 'accept',
              title: "Confirm and Accept",
              onOnCancel: _cache[10] || (_cache[10] = () => {
          _ctx.questionAcceptRejectEdit.isPopConfirmOpened = false;
          _ctx.questionAcceptRejectEdit.state = null;
        }),
              onOnConfirm: _cache[11] || (_cache[11] = () => {
          const cb = () => {
            _ctx.questionAcceptRejectEdit.isPopConfirmOpened = false;
            _ctx.questionAcceptRejectEdit.state = null;
          }
          _ctx.$emit('handleReviewQuestion', _ctx.question.id, _ctx.questionAcceptRejectEdit, cb);

        })
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Are you sure you want to accept \"" + _toDisplayString(_ctx.question.text) + "\"? ", 1)
              ]),
              _: 1
            }, 8, ["is-visible"]),
            _createVNode(_component_new_confirm_modal, {
              "is-visible": _ctx.questionAcceptRejectEdit.isPopConfirmOpened && _ctx.questionAcceptRejectEdit.state === 'edit',
              "accept-caption": 'Yes, save it',
              "reject-caption": 'No, go back',
              title: "Save Edit",
              onOnCancel: _cache[12] || (_cache[12] = ($event: any) => (_ctx.questionAcceptRejectEdit.isPopConfirmOpened = false)),
              onOnConfirm: _cache[13] || (_cache[13] = () => {
          const cb = () => {
            _ctx.questionAcceptRejectEdit.isPopConfirmOpened = false;
            _ctx.questionAcceptRejectEdit.state = null;
          }
          _ctx.$emit('handleReviewQuestion', _ctx.question.id, _ctx.questionAcceptRejectEdit, cb);

        })
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Are you sure you want to accept \"" + _toDisplayString(_ctx.question.text) + "\"? ", 1)
              ]),
              _: 1
            }, 8, ["is-visible"])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}